import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const LANG_STORAGE_KEY = 'makaya_lang';
export const DEFAULT_LANG = 'fr';

export const LANG_OPTIONS = [
  { value: 'fr', label: 'FR' },
];

const MESSAGES = {
  fr: {
    'header.contact': 'Contact',
    'header.reporter': 'Vous Reporter',
    'header.my_account': 'Mon Compte',
    'header.login': 'Se Connecter',
    'header.live': 'En Direct',
    'header.subscribe': "S'abonner",
    'header.logout': 'Déconnexion',
    'header.search_placeholder': 'Rechercher des articles...',
    'header.search_button': 'Rechercher',
    'header.radio_live': 'Radio En Direct',
    'header.terms': "Conditions d'utilisation",
    'header.privacy': 'Politique de confidentialité',
    'header.cookies': 'Cookies',
    'header.advertising': 'Publicité',
    'header.partners': 'Partenaires',
    'header.menu': 'Menu',
    'header.open_menu': 'Ouvrir le menu',
    'header.close_menu': 'Fermer le menu',
    'header.search_aria': 'Rechercher',
    'language.switch_to': 'Changer la langue vers',
    'theme.light': 'Clair',
    'theme.dark': 'Sombre',
    'theme.switch_light': 'Activer le thème clair',
    'theme.switch_dark': 'Activer le thème sombre',
    'admin.section': 'Administration',
    'admin.title': 'Admin',
    'admin.logout': 'Déconnexion',
    'common.loading': 'Chargement...',
    'common.add': 'Ajouter',
    'common.cancel': 'Annuler',
    'common.back': 'Retour',
    'common.unavailable': 'indisponible',
    'admin.nav.dashboard': 'Tableau de bord',
    'admin.nav.articles': 'Articles',
    'admin.nav.categories': 'Catégories',
    'admin.nav.authors': 'Auteurs',
    'admin.nav.media': 'Médias',
    'admin.nav.comments': 'Commentaires',
    'admin.nav.users': 'Utilisateurs',
    'admin.nav.plans': 'Plans',
    'admin.nav.radio': 'Radio',
    'admin.nav.polls': 'Sondages',
    'admin.nav.events': 'Événements',
    'admin.nav.banners': 'Bannières',
    'admin.nav.advertising': 'Publicité',
    'admin.nav.partners': 'Partenaires',
    'admin.nav.newsletter': 'Newsletter',
    'admin.nav.citizen_reports': 'Vous Reporter',
    'admin.nav.rss': 'Import RSS',
    'admin.nav.sections': 'Sections',
    'admin.nav.preview_home': "Aperçu de l'accueil",
    'admin.nav.settings': 'Paramètres',
    'mobile.home': 'Accueil',
    'mobile.news': 'Actualités',
    'mobile.radio': 'Radio',
    'mobile.premium': 'Premium',
    'mobile.account': 'Compte',
    'pwa.install_title': "Installer l'application",
    'pwa.install_desc': "Ajoutez Makaya à l'écran d'accueil pour une expérience native.",
    'pwa.install_ios_desc': 'Sur iPhone: touchez Partager puis "Ajouter à l’écran d’accueil".',
    'pwa.install_android_desc': 'Sur Android: ouvrez le menu du navigateur puis "Ajouter à l’écran d’accueil".',
    'pwa.install_action': 'Installer',
    'pwa.install_later': 'Plus tard',
    'home.breaking_label': 'Alerte Info',
    'home.updated_label': 'Mis à jour',
    'home.alert': 'Alerte',
    'home.premium': 'Premium',
    'home.poll': 'Sondage',
    'home.votes': 'votes',
    'home.no_featured': 'Aucun article en vedette',
    'home.ad_featured': 'Publicité en vedette',
    'home.latest_news': 'Dernières Nouvelles',
    'home.view_all': 'Voir tout',
    'home.most_read': 'Les Plus Lues',
    'home.views': 'vues',
    'home.radio_live': 'Radio En Direct',
    'home.radio_desc': "La radio d'information en continu",
    'home.listen_now': 'Écouter Maintenant',
    'home.go_premium': 'Passez Premium',
    'home.premium_desc': 'Accédez à du contenu exclusif, analyses approfondies et bien plus encore.',
    'home.premium_feature_1': 'Articles exclusifs',
    'home.premium_feature_2': 'Sans publicité',
    'home.premium_feature_3': 'Newsletter premium',
    'home.view_plans': 'Voir les plans',
    'home.stay': 'Restez',
    'home.informed': 'Informé',
    'home.newsletter_desc': 'Recevez les dernières nouvelles directement dans votre boîte mail.',
    'home.email_placeholder': 'Votre adresse email',
    'home.subscribe': "S'inscrire",
    'home.newsletter_success': 'Inscription réussie !',
    'home.newsletter_error': 'Erreur. Réessayez.',
    'home.citizen_journalism': 'Journalisme Citoyen',
    'home.become': 'Devenez',
    'home.reporter': 'Vous Reporter',
    'home.reporter_desc': "Partagez vos informations, photos et vidéos. Contribuez à l'information de proximité.",
    'home.submit_report': 'Soumettre un Rapport',
    'home.partners': 'Nos Partenaires',
    'authors.title': 'Notre Équipe',
    'authors.subtitle': 'Les journalistes et chroniqueurs qui font MAKAYA ENFO.',
    'authors.filter_all': 'Tous',
    'authors.filter_authors': 'Auteurs',
    'authors.filter_columnists': 'Chroniqueurs',
    'authors.columnist': 'Chroniqueur',
    'authors.journalist': 'Journaliste',
    'authors.empty': 'Aucun auteur trouvé',
    'authors.not_found': 'Auteur non trouvé',
    'authors.articles_by': 'Articles de',
    'authors.no_articles': 'Aucun article publié pour le moment.',
    'events.title': 'Événements',
    'events.subtitle': 'Découvrez les événements à venir et passés couverts par MAKAYA ENFO.',
    'events.empty': 'Aucun événement pour le moment.',
    'gallery.title': 'Galeries',
    'gallery.subtitle': 'Photos et vidéos de nos reportages et événements.',
    'gallery.filter_all': 'Toutes',
    'gallery.filter_photo': 'Photos',
    'gallery.filter_video': 'Vidéos',
    'gallery.photo': 'Photo',
    'gallery.video': 'Vidéo',
    'gallery.items': 'éléments',
    'gallery.empty': 'Aucune galerie pour le moment.',
    'gallery.not_found': 'Galerie non trouvée',
    'radio.stream_missing': "Le stream n'est pas encore configuré. Contactez l'administrateur.",
    'radio.schedule': 'Grille des Programmes',
    'radio.hosted_by': 'Présenté par',
    'radio.schedule_soon': 'La grille des programmes sera bientôt disponible.',
    'admin.dashboard.title': 'Tableau de bord',
    'admin.card.published': 'Articles Publiés',
    'admin.card.drafts': 'Articles Brouillons',
    'admin.card.users': 'Utilisateurs',
    'admin.card.subscribers': 'Abonnés Premium',
    'admin.card.comments_pending': 'Commentaires en Attente',
    'admin.card.views': 'Vues Totales',
    'admin.card.newsletter': 'Inscriptions Newsletter',
    'admin.card.revenue': 'Revenus ($)',
    'admin.quick_actions': 'Actions Rapides',
    'admin.qa.manage_articles': 'Gérer les Articles',
    'admin.qa.moderate_comments': 'Modérer les Commentaires',
    'admin.qa.manage_plans': 'Gérer les Plans',
    'admin.qa.settings': 'Paramètres',
    'admin.pending_reports': 'Rapports en Attente',
    'admin.pending.comments': 'Commentaires à modérer',
    'admin.pending.citizen_reports': 'Rapports citoyens',
    'admin.pending.payments_total': 'Total des paiements',
    'admin.rss.title': 'Import RSS',
    'admin.rss.phase_checks': 'Phase 0 - Vérifications',
    'admin.rss.checking': 'Vérification...',
    'admin.rss.update_checks': 'Actualiser checks',
    'admin.rss.run_pilot': 'Lancer pilote CNN/R7/G1',
    'admin.rss.running_pilot': 'Exécution du pilote...',
    'admin.rss.sources': 'Sources RSS',
    'admin.rss.importing': 'Import en cours...',
    'admin.rss.import_active': 'Importer actives',
    'admin.rss.new_source': 'Nouvelle source',
    'admin.rss.import': 'Importer',
    'admin.rss.no_sources': 'Aucune source RSS configurée',
    'admin.rss.phase_pilot': 'Pilote RSS',
    'admin.rss.phase_storage': 'Stockage',
    'admin.rss.phase_ads': 'Annonces',
    'admin.rss.phase_ready': 'Prêt',
    'admin.rss.phase_pending': 'En attente',
    'admin.rss.phase_no_result': 'Aucun résultat de vérification.',
    'admin.rss.phase_healthy': 'saines',
    'admin.rss.phase_active_banners': 'bannières actives',
    'admin.rss.form_name': 'Nom de la source',
    'admin.rss.form_url': 'URL du flux RSS',
    'admin.rss.form_category': '-- Catégorie cible --',
    'admin.rss.form_category_auto': '-- Catégorie automatique via RSS --',
    'admin.rss.form_auto_publish': 'Publication automatique (avec résumé/titre assisté IA)',
    'admin.rss.auto_publish': 'Publier automatiquement après import',
    'admin.rss.auto_publish_short': 'Flux: publication automatique',
    'admin.rss.auto_category': 'automatique',
    'admin.rss.source_cat': 'Cat',
    'admin.rss.source_auto_on': 'Auto publication: ON',
    'admin.rss.source_auto_off': 'Auto publication: OFF',
    'admin.rss.source_imported': 'importés',
    'admin.rss.source_last': 'Dernier',
    'admin.rss.jobs_queue': "File d'importation",
    'admin.rss.jobs_empty': "Aucun article dans la file d'attente",
    'admin.rss.original': 'Original',
    'admin.rss.publish': 'Publier',
    'admin.rss.reject': 'Rejeter',
    'admin.rss.status_pending': 'En attente',
    'admin.rss.status_published': 'Publié',
    'admin.rss.status_rejected': 'Rejeté',
    'admin.rss.status_approved': 'Approuvé',
    'admin.rss.pending_policy': 'Politique active: tout article importé reste EN ATTENTE pour validation manuelle.',
    'admin.rss.pending_policy_short': 'Flux: toujours en attente',
    'footer.tagline': "Votre portail d'information. Analyses, reportages et couverture en temps réel de l'actualité haïtienne et mondiale.",
    'footer.radio_live': 'Radio En Direct',
    'footer.about': 'À propos de Makaya Enfo',
    'footer.sections': 'Rubriques',
    'footer.info': 'Informations',
    'footer.contact_title': 'Contact',
    'footer.contact_desc': 'Pour toute question juridique, éditoriale ou commerciale, contactez directement notre équipe principale.',
    'footer.copyright': 'Tous droits réservés.',
    'footer.privacy_short': 'Confidentialité',
    'footer.social_title': 'Réseaux sociaux',
    'footer.cat.actualites': 'Actualités',
    'footer.cat.politique': 'Politique',
    'footer.cat.economie': 'Économie',
    'footer.cat.societe': 'Société',
    'footer.cat.sport': 'Sport',
    'footer.cat.culture': 'Culture',
    'footer.cat.technologie': 'Technologie',
    'footer.cat.international': 'International',
    'auth.login_title': 'Connexion',
    'auth.login_subtitle': 'Accédez à votre compte',
    'auth.register_title': 'Créer un Compte',
    'auth.register_subtitle': 'Rejoignez la communauté MAKAYA ENFO',
    'auth.error_login': 'Erreur de connexion',
    'auth.error_register': "Erreur d'inscription",
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.full_name': 'Nom complet',
    'auth.placeholder_email': 'votre@email.com',
    'auth.placeholder_password': 'Votre mot de passe',
    'auth.placeholder_name': 'Votre nom',
    'auth.placeholder_password_min': 'Minimum 6 caractères',
    'auth.login_loading': 'Connexion...',
    'auth.login_submit': 'Se Connecter',
    'auth.register_loading': 'Création...',
    'auth.register_submit': 'Créer Mon Compte',
    'auth.no_account': 'Pas encore de compte ?',
    'auth.create_account': 'Créer un compte',
    'auth.has_account': 'Déjà un compte ?',
    'auth.sign_in': 'Se connecter',
    'contact.title': 'Contact',
    'contact.subtitle': 'Envoyez-nous un message et nous vous répondrons dans les plus brefs délais.',
    'contact.success': 'Message envoyé avec succès !',
    'contact.error': 'Erreur. Réessayez.',
    'contact.name_placeholder': 'Votre nom',
    'contact.email_placeholder': 'Votre email',
    'contact.subject_placeholder': 'Sujet',
    'contact.message_placeholder': 'Votre message',
    'contact.send_loading': 'Envoi...',
    'contact.send_submit': 'Envoyer',
    'contact.details': 'Coordonnées',
    'errors.not_found_title': 'Page Non Trouvée',
    'errors.not_found_subtitle': "La page que vous recherchez n'existe pas ou a été déplacée.",
    'errors.server_title': 'Erreur Serveur',
    'errors.server_subtitle': 'Une erreur interne est survenue. Veuillez réessayer ultérieurement.',
    'errors.back_home': "Retour à l'Accueil",
    'plans.badge': 'Abonnement Premium',
    'plans.title': 'Accédez à Tout le Contenu',
    'plans.subtitle': 'Rejoignez des milliers de lecteurs premium et accédez à nos analyses approfondies, reportages exclusifs et bien plus.',
    'plans.monthly': 'Mensuel',
    'plans.yearly': 'Annuel',
    'plans.recommended': 'Recommandé',
    'plans.per_month': '/mois',
    'plans.per_year': '/an',
    'plans.free_trial': "jours d'essai gratuit",
    'plans.checkout_error': 'Erreur lors de la création de la session de paiement.',
    'plans.loading_action': 'Chargement...',
    'plans.subscribe_action': "S'abonner",
    'plans.empty': "Les plans d'abonnement seront bientôt disponibles.",
    'subscription.checking_title': 'Vérification du paiement...',
    'subscription.checking_subtitle': 'Merci de patienter quelques instants.',
    'subscription.success_title': 'Bienvenue Premium !',
    'subscription.success_subtitle': 'Votre abonnement a été activé avec succès. Vous avez maintenant accès à tout le contenu exclusif de MAKAYA ENFO.',
    'subscription.explore': 'Explorer le Contenu',
    'subscription.profile': 'Mon Profil',
    'subscription.expired': 'Session expirée',
    'subscription.timeout': 'Délai dépassé',
    'subscription.error': 'Erreur',
    'subscription.failure_subtitle': "Le paiement n'a pas pu être confirmé. Veuillez réessayer ou contacter le support.",
    'subscription.back_plans': 'Retour aux Plans',
    'reporter.title_prefix': 'Vous',
    'reporter.title_highlight': 'Reporter',
    'reporter.subtitle': 'Partagez vos informations, témoignages et reportages citoyens.',
    'reporter.success': 'Votre rapport a été soumis avec succès ! Notre équipe le traitera rapidement.',
    'reporter.error': 'Erreur. Réessayez.',
    'reporter.title_placeholder': 'Titre de votre rapport',
    'reporter.description_placeholder': 'Description brève',
    'reporter.content_placeholder': 'Détails complets (optionnel)',
    'reporter.location_placeholder': 'Localisation',
    'reporter.contact_placeholder': 'Votre contact (email ou téléphone)',
    'reporter.consent': 'En soumettant ce formulaire, vous acceptez que MAKAYA ENFO utilise les informations fournies pour la couverture éditoriale.',
    'reporter.loading': 'Envoi...',
    'reporter.submit': 'Soumettre Mon Rapport',
    'article.gallery': 'Galerie',
    'article.photos': 'photos',
    'article.video': 'Vidéo',
    'article.video_unsupported': 'Votre navigateur ne supporte pas la vidéo.',
    'article.comment_pending': 'Commentaire soumis pour modération',
    'article.comment_error_login': "Erreur. Connectez-vous d'abord.",
    'article.not_found': 'Article non trouvé',
    'article.back_home': "Retour à l'accueil",
    'article.home': 'Accueil',
    'article.premium': 'Premium',
    'article.sponsored': 'Sponsorisé',
    'article.source': 'Source',
    'article.views': 'vues',
    'article.sponsored_content': 'Contenu sponsorisé',
    'article.premium_locked_title': 'Contenu Réservé aux Abonnés',
    'article.premium_locked_desc': "Cet article est réservé aux abonnés premium. Abonnez-vous pour accéder à tous nos contenus exclusifs.",
    'article.premium_locked_cta': "S'abonner Maintenant",
    'article.author_role': 'Journaliste - MAKAYA ENFO',
    'article.comments': 'Commentaires',
    'article.comment_placeholder': 'Votre commentaire...',
    'article.comment_submit': 'Publier',
    'article.login_to_comment': 'Connectez-vous pour laisser un commentaire.',
    'article.no_comments': 'Aucun commentaire pour le moment. Soyez le premier !',
    'article.related': 'Articles Similaires',
    'article.advertising': 'Publicité',
    'admin.articles.title': 'Articles',
    'admin.articles.new': 'Nouvel Article',
    'admin.articles.editor_edit': "Modifier l'Article",
    'admin.articles.editor_new': 'Nouvel Article',
    'admin.articles.required_title': 'Le titre est obligatoire.',
    'admin.articles.required_category': 'Veuillez sélectionner une catégorie.',
    'admin.articles.save_error': 'Erreur lors de la sauvegarde',
    'admin.articles.delete_confirm': 'Supprimer cet article ?',
    'admin.articles.delete_error': 'Erreur lors de la suppression',
    'admin.articles.ai_error': 'Erreur IA',
    'admin.articles.publication': 'Publication',
    'admin.articles.label_title': 'Titre',
    'admin.articles.label_subtitle': 'Sous-titre',
    'admin.articles.label_content': 'Contenu',
    'admin.articles.label_excerpt': 'Résumé',
    'admin.articles.placeholder_title': "Titre de l'article",
    'admin.articles.placeholder_subtitle': 'Sous-titre',
    'admin.articles.placeholder_content': "Contenu HTML de l'article...",
    'admin.articles.placeholder_excerpt': "Résumé de l'article",
    'admin.articles.status_draft': 'Brouillon',
    'admin.articles.status_review': 'En révision',
    'admin.articles.status_published': 'Publié',
    'admin.articles.status_archived': 'Archivé',
    'admin.articles.category_placeholder': '-- Catégorie --',
    'admin.articles.subcategory_placeholder': '-- Sous-catégorie (optionnel) --',
    'admin.articles.author_placeholder': "Nom de l'auteur",
    'admin.articles.gallery_label': 'Galerie de Photos',
    'admin.articles.gallery_helper': 'Ajoutez plusieurs photos à la galerie',
    'admin.articles.video_label': 'URL de la vidéo',
    'admin.articles.video_placeholder': 'https://youtube.com/watch?v=... ou lien direct .mp4',
    'admin.articles.reading_time_placeholder': 'Temps de lecture (min)',
    'admin.articles.options': 'Options',
    'admin.articles.featured': 'Article en vedette',
    'admin.articles.breaking': 'Alerte info',
    'admin.articles.premium': 'Contenu premium',
    'admin.articles.seo': 'SEO',
    'admin.articles.seo_title_placeholder': 'Titre SEO',
    'admin.articles.seo_description_placeholder': 'Description SEO',
    'admin.articles.tags': 'Tags',
    'admin.articles.tags_placeholder': 'tag1, tag2, tag3',
    'admin.articles.update': 'Mettre à Jour',
    'admin.articles.publish': 'Publier',
    'admin.articles.filter_all': 'Tous',
    'admin.articles.views': 'vues',
    'admin.categories.title': 'Catégories',
    'admin.categories.new': 'Nouvelle Catégorie',
    'admin.categories.form_edit': 'Modifier la Catégorie',
    'admin.categories.form_new': 'Nouvelle Catégorie',
    'admin.categories.name_placeholder': 'Nom de la catégorie',
    'admin.categories.description_placeholder': 'Description',
    'admin.categories.order_placeholder': 'Ordre',
    'admin.categories.save': 'Enregistrer',
    'admin.categories.delete_confirm': 'Supprimer ?',
    'admin.categories.delete_error': 'Erreur',
    'admin.categories.active': 'Actif',
    'admin.categories.inactive': 'Inactif',
    'admin.categories.empty': 'Aucune catégorie',
  },
};

const I18nContext = createContext(null);

function getInitialLanguage() {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANG_STORAGE_KEY, DEFAULT_LANG);
  }
  return DEFAULT_LANG;
}

export function I18nProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = useCallback(() => {
    setLanguageState(DEFAULT_LANG);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LANG_STORAGE_KEY, DEFAULT_LANG);
    }
  }, []);

  const t = useCallback((key, fallback = '') => {
    return MESSAGES[language]?.[key] || MESSAGES[DEFAULT_LANG]?.[key] || fallback || key;
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = DEFAULT_LANG;
    }
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LANG_STORAGE_KEY, DEFAULT_LANG);
    }
  }, []);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
